import React, { useState, useEffect } from 'react';
import styled, {keyframes} from 'styled-components';
import loadingGif from '../assets/images/loading.gif';

const rumble = keyframes`
  from { transform: translateX(-0.1rem); }
  to { transform: translateY(0.1rem); }
`;

const Holder = styled.div`
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.colours.loadingBackground};
  color: ${props => props.theme.colours.black};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 3rem 3rem;
  text-align: center;
  > .inner {
    max-width: ${props => props.theme.maxWidth};
    img {
      max-width: 32rem;
      animation: ${rumble} 0.1s linear infinite;
    }
  }
`;

function LoadingScreen() {

  const [loading, setLoading] = useState(true);

  useEffect( () => {
    const timer = setTimeout( () => {
      setLoading(false);
    }, 4500 );
    return () => clearTimeout( timer );
  }, [] );

  if( !loading ) { return null; }

  return (
    <Holder>
      <div className="inner">
        <img src={loadingGif} alt="loading"/>
        <p>Thank you for selecting all the labels.</p>
        <h3><strong>Your avatar is being generated.</strong></h3>
      </div>
    </Holder>
  )
}

export default LoadingScreen;
